!(function (t) {
    var e = {};
    function r(o) {
        if (e[o]) return e[o].exports;
        var n = (e[o] = { i: o, l: !1, exports: {} });
        return t[o].call(n.exports, n, n.exports, r), (n.l = !0), n.exports;
    }
    (r.m = t),
        (r.c = e),
        (r.d = function (t, e, o) {
            r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: o });
        }),
        (r.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (r.t = function (t, e) {
            if ((1 & e && (t = r(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if ((r.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
                for (var n in t)
                    r.d(
                        o,
                        n,
                        function (e) {
                            return t[e];
                        }.bind(null, n)
                    );
            return o;
        }),
        (r.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return r.d(e, "a", e), e;
        }),
        (r.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (r.p = ""),
        r((r.s = 0));
})([
    function (t, e, r) {
        "use strict";
        r.r(e);
        class o {
            constructor(t, e) {
                (this.id = t), (this.container = e), (this.dom = { gallery: "[data-product-gallery]", galleryDots: "[data-product-gallery-dots]", galleryDotsNavigation: "[data-product-gallery-dots-navigation]" });
            }
            bindUIActions() {
                if (!$(this.dom.gallery, this.container).length) return;
                const t = `[data-product-container="${this.id}"]`;
                $(this.dom.gallery, this.container).slick({
                    mobileFirst: !0,
                    arrows: true,
                    initialSlide: 1,
                    dots: !0,
                    appendArrows: ".product__gallery-dots-container",
					autoplay: false,
                    autoplaySpeed:3000,
                    dotsClass: "product__gallery-dots",
                    appendDots: `${t} ${this.dom.galleryDots}`,
                    nextArrow:
                        '<button class="product__gallery-arrow slick-next slick-arrow" type="button" aria-label="Next"><svg class="icon--root icon--chevron-down" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline;"><path d="M20.0001 27.1875C19.7516 27.1866 19.5136 27.0878 19.3376 26.9125L6.83755 14.4125C6.67195 14.2348 6.5818 13.9997 6.58608 13.7568C6.59037 13.514 6.68876 13.2822 6.86052 13.1105C7.03229 12.9387 7.26402 12.8403 7.5069 12.836C7.74978 12.8317 7.98483 12.9219 8.16255 13.0875L20.0001 24.925L31.8376 13.0875C32.0153 12.9219 32.2503 12.8317 32.4932 12.836C32.7361 12.8403 32.9678 12.9387 33.1396 13.1105C33.3113 13.2822 33.4097 13.514 33.414 13.7568C33.4183 13.9997 33.3282 14.2348 33.1626 14.4125L20.6626 26.9125C20.4865 27.0878 20.2485 27.1866 20.0001 27.1875Z" fill="#1A1A1A" stroke="black" stroke-width="0.5"></path></svg></button>',
                    prevArrow:
                        '<button class="product__gallery-arrow slick-prev slick-arrow" type="button" aria-label="Previous"><svg class="icon--root icon--chevron-up" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline;"><path d="M32.5001 27.1875C32.2516 27.1866 32.0136 27.0878 31.8376 26.9125L20.0001 15.075L8.16255 26.9125C7.98483 27.0781 7.74978 27.1682 7.5069 27.164C7.26402 27.1597 7.03229 27.0613 6.86052 26.8895C6.68876 26.7177 6.59037 26.486 6.58608 26.2431C6.5818 26.0003 6.67195 25.7652 6.83755 25.5875L19.3376 13.0875C19.4242 12.9998 19.5273 12.9302 19.6411 12.8827C19.7548 12.8352 19.8768 12.8107 20.0001 12.8107C20.1233 12.8107 20.2453 12.8352 20.3591 12.8827C20.4728 12.9302 20.5759 12.9998 20.6626 13.0875L33.1626 25.5875C33.2905 25.7197 33.3771 25.8865 33.4115 26.0672C33.446 26.248 33.4268 26.4349 33.3564 26.6049C33.286 26.7749 33.1674 26.9207 33.0153 27.0242C32.8631 27.1277 32.6841 27.1844 32.5001 27.1875Z" fill="#1A1A1A" stroke="black" stroke-width="0.5"></path></svg></button>',
                    customPaging: (t, e) => {
                        return `<button type="button" class="product__gallery-dots-button"><img src="${$(t.$slides[e]).data("thumbnail")}" class="lazy" />${
                            $(t.$slides[e]).data("video") || !1 ? '<svg width="22" height="22"><use xmlns:xlink href="#play" /></svg>' : ""
                        }</button>`;
                    },
                    responsive: [{ breakpoint: 1024, settings: { arrows:true } }],
                }),


        

$(document).ready(function() {
    // Récupérer l'ID du produit Shopify
    var productId;
    if (typeof ShopifyAnalytics !== 'undefined' && typeof ShopifyAnalytics.meta !== 'undefined' && typeof ShopifyAnalytics.meta.product !== 'undefined') {
        productId = ShopifyAnalytics.meta.product.id;
        console.log('Product ID:', productId);

        // Vérifiez si l'ID du produit est 2956225541
        if (productId == 2956225541) {
            var selectedVariant = document.querySelector('.radios--input:checked');
            if (selectedVariant) {
                var variantDataRobin = selectedVariant.getAttribute('data-robin');
                if (variantDataRobin) {
                    // Ajoutez un point devant la variable
                    $(".product__gallery-slides").slick('slickFilter', '.' + variantDataRobin);
                } else {
                    console.error('Aucune variante sélectionnée.');
                }
            } else {
                console.error('Aucune variante sélectionnée.');
            }
        }
      if (productId == 5268511493) {
            var selectedVariant = document.querySelector('.radios--input:checked');
            if (selectedVariant) {
                var variantDataRobin = selectedVariant.getAttribute('data-robin');
                if (variantDataRobin) {
                    // Ajoutez un point devant la variable
                    $(".product__gallery-slides").slick('slickFilter', '.' + variantDataRobin);
                } else {
                    console.error('Aucune variante sélectionnée.');
                }
            } else {
                console.error('Aucune variante sélectionnée.');
            }
        }
      if (productId == 10259360329) {
            var selectedVariant = document.querySelector('.radios--input:checked');
            if (selectedVariant) {
                var variantDataRobin = selectedVariant.getAttribute('data-robin');
                if (variantDataRobin) {
                    // Ajoutez un point devant la variable
                    $(".product__gallery-slides").slick('slickFilter', '.' + variantDataRobin);
                } else {
                    console.error('Aucune variante sélectionnée.');
                }
            } else {
                console.error('Aucune variante sélectionnée.');
            }
        }
      if (productId == 6969607192689) {
            var selectedVariant = document.querySelector('.radios--input:checked');
            if (selectedVariant) {
                var variantDataRobin = selectedVariant.getAttribute('data-robin');
                if (variantDataRobin) {
                    // Ajoutez un point devant la variable
                    $(".product__gallery-slides").slick('slickFilter', '.' + variantDataRobin);
                } else {
                    console.error('Aucune variante sélectionnée.');
                }
            } else {
                console.error('Aucune variante sélectionnée.');
            }
        }
    } 
});


              
     

              
  $(".radios--value-button div").on('click', function(){
    var filter = $(this).data('filter');
    $(".product__gallery-slides").slick('slickUnfilter');    
     if(filter == '8floz'){$(".product__gallery-slides").slick('slickFilter','.-8floz')}
else if(filter == '6floz'){$(".product__gallery-slides").slick('slickFilter','.-6floz')}
else if(filter == '16floz'){$(".product__gallery-slides").slick('slickFilter','.-16floz')}
else if(filter == '1floz'){$(".product__gallery-slides").slick('slickFilter','.-1floz')}
else if(filter == '8oz'){$(".product__gallery-slides").slick('slickFilter','.-8oz')}
else if(filter == '15oz'){$(".product__gallery-slides").slick('slickFilter','.-15oz')}
else if(filter == '4-Pack'){$(".product__gallery-slides").slick('slickFilter','.-4-Pack')}
else if(filter == '6-Pack'){$(".product__gallery-slides").slick('slickFilter','.-6-Pack')}
else if(filter == '16-oz'){$(".product__gallery-slides").slick('slickFilter','.-16-oz')}
else if(filter == '8-oz'){$(".product__gallery-slides").slick('slickFilter','.-8-oz')}
else if(filter == 'all'){$(".product__gallery-slides").slick('slickUnfilter')}

  }),


    
                    $(this.container).on("click", this.dom.galleryDotsNavigation, (t) => $(this.dom.gallery, this.container).slick(t.currentTarget.dataset.productGalleryDotsNavigation));
            }
            init() {
                this.bindUIActions();
            }
        }
        const n = "[data-product-container]",
            i = () => {
                $(n).each(function () {
                    const t = $(this),
                        e = t.attr("data-product-container");
                    new o(e, t).init();
                });
            };
        (r.p = window.__webpack_public_path__),
            document.addEventListener("DOMContentLoaded", () => {
                i();
            });
    },
])
  ;

$(".slidecarthq-overlay").attr('aria-label',"overlay");

var $slickElement = $('.product__gallery-slides');


// Organic Castor oil

$('.2956225541- .radios--value-button div[data-filter="16floz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.2956225541- .radios--value-button div[data-filter="8floz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.2956225541- .radios--value-button div[data-filter="6floz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});

// Sweet Almond oil

$('.5268511493- .radios--value-button div[data-filter="1floz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.5268511493- .radios--value-button div[data-filter="16floz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});

// Organic Shea Butter

$('.10259360329- .radios--value-button div[data-filter="8oz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.10259360329- .radios--value-button div[data-filter="15oz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});

// Organic Lip Balms

$('.8029548681- .radios--value-button div[data-filter="4-Pack"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.8029548681- .radios--value-button div[data-filter="6-Pack"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});

// Castor Oil Pack Kit

$('.6969607192689- .radios--value-button div[data-filter="16-oz"]').on('click', function() {  $slickElement.slick('slickGoTo', 0);});
$('.6969607192689- .radios--value-button div[data-filter="8-oz"]').on('click', function() {   $slickElement.slick('slickGoTo', 0);});